import React from 'react';
import { FadeIn } from './FadeIn';
export function HeroSection() {
  return <section className="bg-white pt-14 pb-8 px-6 md:px-12 lg:px-24" data-id="element-90">
      <div className="max-w-4xl mx-auto text-center" data-id="element-91">
        <FadeIn data-id="element-92">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-text-black leading-tight mb-6" data-id="element-93">
            Descubre el protocolo de 7 días que ya está ayudando a mujeres de
            +55 a moverse sin dolor… sin pastillas
          </h1>
        </FadeIn>
        <FadeIn delay={0.2} data-id="element-94">
          <p className="text-xl md:text-2xl text-text-gray font-medium max-w-3xl mx-auto leading-relaxed" data-id="element-95">
            Lo que realmente está causando tu dolor… y cómo empezar a reducirlo
            desde tu cocina en solo 1 semana
          </p>
        </FadeIn>
      </div>
    </section>;
}